import { render, staticRenderFns } from "./QSearchNeedsAnalysisLead.vue?vue&type=template&id=4af0deea&"
import script from "./QSearchNeedsAnalysisLead.vue?vue&type=script&lang=js&"
export * from "./QSearchNeedsAnalysisLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports